import { render, staticRenderFns } from "./coach_group_manage_coach.vue?vue&type=template&id=0ce358d4&"
import script from "./coach_group_manage_coach.vue?vue&type=script&lang=js&"
export * from "./coach_group_manage_coach.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports